// Story 012 — per-image viewport persistence. Mirrors Aerios IQ's
// `viewerZoomAreasByImage` heritage (`.vibe/19` §1.2): switching images
// and switching back restores the zoom + center the user left behind.
// Client-only for MVP per `.vibe/19` §6 Q7 (last-write-wins; no server
// round-trip until a future story).
import { create } from "zustand";

export interface ViewportState {
  /** OSD zoom level (1.0 = fit-to-width default). */
  zoom: number;
  /** OSD viewport centre, normalised image coords (0..1). */
  centerX: number;
  centerY: number;
}

export interface ViewerZoomStoreState {
  byImage: Record<string, ViewportState>;
  getViewport: (imageId: string) => ViewportState | undefined;
  setViewport: (imageId: string, viewport: ViewportState) => void;
  reset: () => void;
}

export const useViewerZoomStore = create<ViewerZoomStoreState>((set, get) => ({
  byImage: {},
  getViewport: (imageId) => get().byImage[imageId],
  setViewport: (imageId, viewport) => {
    set((state) => ({
      byImage: { ...state.byImage, [imageId]: viewport },
    }));
  },
  reset: () => {
    set({ byImage: {} });
  },
}));
